import BigNumber from 'bignumber.js';

import {
  getChainIdByEnv,
  getExtendedErrorText,
  mainApi,
  queryFnNotifyWrapper,
} from 'modules/api';
import { withProvider } from 'modules/auth';
import { currentEnv } from 'modules/common';
import { KnownDialogs, openDialog } from 'modules/dialogs';

import { unstake } from '../api/unstake';
import { stakeCacheTags } from '../stakeCacheTags';

type Args = {
  amount: BigNumber.Value;
};

export const { useUnstakeMutation } = mainApi.injectEndpoints({
  endpoints: build => ({
    unstake: build.mutation<void, Args>({
      queryFn: queryFnNotifyWrapper<Args, never, { digest: number }>(
        async args =>
          withProvider({
            args,
            call: async ({ provider, amount }) => {
              const client = provider.getClient();

              const { digest } = await unstake({
                chainId: getChainIdByEnv(currentEnv),
                wallet: provider.getWallet(),
                walletAccount: provider.getWalletAccount(),
                client,
                amount: new BigNumber(amount),
                env: currentEnv,
              });

              await client.waitForTransaction({ digest });

              return { data: { digest } };
            },
          }),
        error => getExtendedErrorText(error, 'Failed to unstake'),
      ),
      async onQueryStarted({ amount }, { dispatch, queryFulfilled }) {
        await queryFulfilled;

        dispatch(
          openDialog({
            currentModal: KnownDialogs.successUnstake,
            amount: new BigNumber(amount),
          }),
        );
      },
      invalidatesTags: [stakeCacheTags.stake],
    }),
  }),
});
